/* 🤖 this file was generated by svg-to-ts */

import { SiriusFlag } from './build/sirius-flags.model';

export type SiriusFlagNameSubset<
  T extends Readonly<SiriusFlag[]>
> = T[number]['name'];

export * from './build/sirius-flag_cs.icon';
export * from './build/sirius-flag_da-DK.icon';
export * from './build/sirius-flag_de-DE.icon';
export * from './build/sirius-flag_en-GB.icon';
export * from './build/sirius-flag_en-US.icon';
export * from './build/sirius-flag_es-ES.icon';
export * from './build/sirius-flag_es-MX.icon';
export * from './build/sirius-flag_fi.icon';
export * from './build/sirius-flag_fr-FR.icon';
export * from './build/sirius-flag_hu.icon';
export * from './build/sirius-flag_it-IT.icon';
export * from './build/sirius-flag_ja.icon';
export * from './build/sirius-flag_ko.icon';
export * from './build/sirius-flag_nb.icon';
export * from './build/sirius-flag_nl-BE.icon';
export * from './build/sirius-flag_pl.icon';
export * from './build/sirius-flag_pt-BR.icon';
export * from './build/sirius-flag_pt-PT.icon';
export * from './build/sirius-flag_ro.icon';
export * from './build/sirius-flag_se.icon';
export * from './build/sirius-flag_th.icon';
export * from './build/sirius-flag_tr.icon';
export * from './build/sirius-flag_vi.icon';
export * from './build/sirius-flag_zh-Hans.icon';
export * from './build/sirius-flag_zh-Hant.icon';
export * from './build/complete-flag-set';
export * from './build/sirius-flags.model';
